export default __webpack_public_path__ + "static/profile-pic-2-00514a30af6af00a7e7fdddcdea03b94.jpeg";